import { syncSponsorAddressPrefill } from './address';
import { syncSponsorContactInfoPrefill } from './contactInfo';
import { syncSponsorDisabilityPrefill } from './disability';
import { syncSponsorPrefill } from './personalInfo';

export * from './address';
export * from './contactInfo';
export * from './disability';
export * from './personalInfo';
export { canUseSponsorPrefill } from './shared';

const SYNCS = [
  syncSponsorPrefill,
  syncSponsorAddressPrefill,
  syncSponsorContactInfoPrefill,
  syncSponsorDisabilityPrefill,
];

/**
 * Runs each sponsor prefill sync in order. Returns the same reference when
 * nothing changes.
 *
 * @param {Object} formData - the current form data
 * @returns {Object} updated form data
 */
export const syncSponsorPrefillData = formData =>
  SYNCS.reduce((data, sync) => sync(data), formData);
